<script>
export default {
  name: 'Breadcrumbs',
  props: {
    basePath: {
      type: String,
      default: ''
    },
    path: {
      type: String,
      default: ''
    }
  },
  computed: {
    // Generates an array of breadcrumbs for the specified path
    breadcrumbs() {
      const path = this.path;
      const breadcrumbs = [];
      const hasSlash = path.charAt(0) === '/';

      if (hasSlash) {
        // Handle paths that start with a slash
        const chunks = path.substring(1).split('/');

        if (path !== '/') {
          breadcrumbs.push({ name: '/', path: '/' });
        }

        for (let i = 0; i < chunks.length; i++) {
          breadcrumbs.push({
            name: chunks[i],
            path: '/' + chunks.slice(0, i + 1).join('/')
          });
        }
      } else {
        // Handle paths that don't start with a slash
        const chunks = path.split('/');

        if (path !== '') {
          breadcrumbs.push({ name: '', path: '' });
        }

        for (let i = 0; i < chunks.length; i++) {
          breadcrumbs.push({
            name: chunks[i],
            path: chunks.slice(0, i + 1).join('/')
          });
        }
      }

      // Remove everything below the base path
      return breadcrumbs.filter(breadcrumb => {
        return breadcrumb.path.length >= this.basePath.length;
      });
    }
  }
};
</script>

<template>
  <nav class="file-list-breadcrumbs">
    <a
      v-for="(chunk, index) in breadcrumbs"
      :key="index"
      :title="chunk.path"
      href="#"
      @click.prevent="$emit('path-change', chunk.path)"
    >
      <i v-if="index === 0" class="el-icon-fa-home" />
      <span v-else>{{ chunk.name }}</span>
    </a>
  </nav>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.file-list-breadcrumbs {
  font-size: $--font-size-small;
  line-height: 1.5;
  padding: 0.25rem 0;
  margin-bottom: 0.5rem;

  a {
    &:last-child {
      color: $--color-gray-30;
      pointer-events: none;
    }

    &:not(:last-child)::after {
      content: '/';
      color: $--color-gray-30;
      margin-left: 0.25rem;
      margin-right: 0.25rem;
    }

    > i {
      margin-right: 0.125rem;
    }
  }
}
</style>
